import createSvgIcon from '../../Utils/CreateSvgIcon';

export const AutoApproval = createSvgIcon(
  <path
    d="M16.8379 7.94238C17.21 6.45924 18.8042 5.64387 20.2246 6.20996C21.1852 6.59292 21.8152 7.5226 21.8154 8.55664V11.9834H25.9824C27.9439 11.9836 29.3776 13.8354 28.8867 15.7344L26.9502 23.2197L26.7559 23.9697H16.166V24H11V13.7012H14.416L16.2588 10.249L16.8379 7.94238ZM13 22H14.1328V15.7012H13V22ZM19.4844 8.06738C19.1883 7.94955 18.855 8.11966 18.7773 8.42871L18.1689 10.8545L18.1396 10.9746L18.0811 11.083L16.166 14.668V21.9697H25.208L26.9502 15.2334C27.1135 14.6006 26.636 13.9836 25.9824 13.9834H19.8154V8.55664C19.8152 8.34133 19.6844 8.14723 19.4844 8.06738Z"
    transform="translate(-8 -4)"
    fillRule="evenodd"
    clipRule="evenodd"
  />,
  'AutoApproval',
);
